import { render, staticRenderFns } from "./sidebar-layout.vue?vue&type=template&id=e0dcf636&"
import script from "./sidebar-layout.vue?vue&type=script&lang=ts&"
export * from "./sidebar-layout.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAppBar,VAppBarNavIcon,VContainer,VFooter,VMain})
